import { map } from "lodash";
import { useCallback } from "react";

import { SKUPageContentTab, SKUPageContentTabType } from "@/data/types";
import { useCMSStore } from "@/hooks/use-cms-store";

import { CMSAddTabButton } from "./cms-add-tab-button";
import { CMSAudioTab } from "./cms-audio-tab";
import { CMSBuilderTab } from "./cms-builder-tab";
import { CMSGalleryTab } from "./cms-gallery-tab";
import { CMSProductTab } from "./cms-product-tab";
import { CMSUniqueTab } from "./cms-unique-tab";
import { CMSWebpageTab } from "./cms-webpage-tab";

export const CMSTabs = () => {
  const data = useCMSStore((state) => state.pageContent?.data);

  const renderTab = useCallback((tab: SKUPageContentTab, index: number) => {
    const tabKey = `${tab.type}-${index}`;

    switch (tab.type) {
      case SKUPageContentTabType.PRODUCT_TAB:
        return (
          <CMSProductTab key={tabKey} index={index} options={tab.options} />
        );
      case SKUPageContentTabType.MUSIC_TAB:
        return (
          <CMSAudioTab
            key={tabKey}
            index={index}
            options={tab.options}
            tracks={tab.data}
          />
        );
      case SKUPageContentTabType.GALLERY_TAB:
        return (
          <CMSGalleryTab
            key={tabKey}
            index={index}
            options={tab.options}
            data={tab.data}
          />
        );
      case SKUPageContentTabType.BUILDER_IO_TAB:
        return (
          <CMSBuilderTab key={tabKey} index={index} options={tab.options} />
        );
      case SKUPageContentTabType.UNIQUE_TAB:
        return (
          <CMSUniqueTab
            key={tabKey}
            index={index}
            options={tab.options}
            data={tab.data}
          />
        );
      case SKUPageContentTabType.WEBPAGE_TAB:
        return (
          <CMSWebpageTab key={tabKey} index={index} options={tab.options} />
        );
      default:
        return null;
    }
  }, []);

  return (
    <div className="flex-1">
      <h3 className="text-lg font-medium mb-2">Tabs</h3>
      <p className="text-sm text-muted-foreground mb-6">
        Add tabs to create a multi-page experience from one view, or opt to only
        have one tab for your end-consumers. Each Webpage is limited to 5 tabs.
      </p>
      <div>{map(data, (tab, index) => renderTab(tab, index))}</div>
      <CMSAddTabButton />
    </div>
  );
};
